module.exports = __webpack_public_path__ + "static/img/google-qrcode.ec3ff41.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/google-qrcode.png
// module id = twid
// module chunks = 0